<script setup lang="ts">
import { UpdateType } from './UpdateWizard.vue';
import { computed } from 'vue';
import { useTranslation } from 'i18next-vue';
const { t } = useTranslation();

export type WizardStepWelcomeProps = {
  targetVersion: string;
  type: UpdateType;
};

const props = defineProps<WizardStepWelcomeProps>();

const text = computed(() => {
  switch (props.type) {
    case 'update':
      return {
        header: t('UpdateWelcomeStepHeader'),
        message: t('UpdateWelcomeStepMsg', {
          version: props.targetVersion,
        }),
      };
    case 'upgrade':
      return {
        header: t('UpgradeWelcomeStepHeader'),
        message: t('UpgradeWelcomeStepMsg', {
          version: props.targetVersion,
        }),
      };
    default:
      throw new Error(`Unknown Updated Type ${props.type}`);
  }
});
</script>

<template>
  <h2 class="mb-8 mt-5 on-off-white">
    {{ text.header }}
  </h2>

  <p class="text-pre-line">
    {{ text.message }}
  </p>
</template>
